// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2gjtc","expireSoon":"styles_expireSoon__3_u9I"};